<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> COLEÇÃO </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="collection.id"
          >{{ collection.id }} -
          {{ collection.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="collection.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-radio-group v-model="collection.type_selection" row>
                <v-radio label="Selecionar Cor" value="color"></v-radio>
                <v-radio label="Selecionar Imagem" value="image"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="collection.type_selection === 'color'">
            <v-col cols="12" xs="12" md="4">
              <p class="font-weight-bold">Escolher a Cor da Coleção</p>
              <v-color-picker
                dot-size="25"
                swatches-max-height="200"
                hide-inputs
                v-model="collection.color"
              ></v-color-picker>
              <label class="font-weight-bold">{{
                this.collection.color
              }}</label>
            </v-col>
          </v-row>
          <v-row v-if="collection.type_selection === 'image'">
            <v-col>
              <v-row v-if="collection.photo">
                <v-col cols="12" xs="12" md="4">
                  <v-img
                    :lazy-src="getUrlPhoto(collection.photo)"
                    max-height="100"
                    contain
                    :src="getUrlPhoto(collection.photo)"
                  ></v-img>
                </v-col>
                <v-col cols="12" xs="12" md="8">
                  <v-btn
                    dark
                    small
                    text
                    color="red darken-3"
                    @click="deleteImage()"
                    >Excluir Imagem</v-btn
                  >
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" xs="12" md="4">
                  <v-file-input
                    label="Cabeçalho"
                    outlined
                    dense
                    required
                    :error-messages="errorPhotoMessage"
                    @change="onFilePicked"
                    accept="image/*"
                    prepend-icon="mdi-camera"
                  ></v-file-input>
                </v-col>
                <v-col cols="12" xs="12" md="8"> </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="collection.status"
                :label="`Status: ${getLabelStatus(collection.status)}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL_IMAGE } from "@/api/config";

import * as API from "@/api/requests/CollectionRequest";

export default {
  components: {},
  data: () => ({
    loading: false,
    photo: "",
    errorPhotoMessage: "",
    collection: {
      id: "",
      name: "",
      status: 1,
      color: "#5800FF",
      type_selection: "color",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getCollection(this.$route.params.id);
      }
    },
    async getCollection(id) {
      // this.showLoading();
      this.loading = true;
      try {
        let data = await API.getById(id);
        if (data.color == null && data.photo === null) {
          data.color = "#5800FF";
        }
        if (data.photo !== null) {
          data.color = "#FFFFFF";
          data.type_selection = "image";
        } else {
          data.type_selection = "color";
        }
        this.collection = data;
      } catch (error) {
        this.collection = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "Collection" });
    },
    onFilePicked(e) {
      this.photo = e;
      this.errorPhotoMessage = "";
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.photo === "" && this.collection.photo == "") {
          this.errorPhotoMessage = "Campo Obrigatorio";
          return false;
        }
        let form = new FormData();
        form.append("name", this.collection.name.toUpperCase());
        form.append("status", this.collection.status ? 1 : 0);
        form.append("type_selection", this.collection.type_selection);
        form.append(
          "color",
          this.collection.type_selection == "color"
            ? this.collection.color
            : null
        );
        form.append(
          "photo",
          this.photo !== "" ? this.photo : this.collection.photo
        );
        if (this.collection.id === "") {
          this.post(form);
        } else {
          // form.append("_method", "PUT");
          this.update(this.collection.id, form);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    getUrlPhoto(photo) {
      if (photo !== "") {
        return `${URL_IMAGE}${photo}`;
      } else {
        return "";
      }
    },
    deleteImage() {
      this.photo = "";
      this.collection.photo = "";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
